<template>
  <div :class="{'article-feature text-body dh-psy-list': true, 'dh-psy-list--dark': dark}">
    <ul>
      <li v-for="(listItem, idx) in item.value" :key="idx">
        <span v-html="listItem.value" />
      </li>
    </ul>
  </div>
</template>

<style scoped lang="postcss">
  div.article-feature.text-body.dh-psy-list {
    padding: 0 18px;
    padding: 0 1.125rem;
    color: inherit;

    @media (min-width: 800px) {
      font-size: 1.125em;
    }

    line-height: 2.4;
  }

  .article-feature.dh-psy-list > * {
    padding: 18px 0 18px 18px;
    float: none;

    @media (min-width: 800px) {
      padding: 18px 0;
    }
  }

  .text-body.dh-psy-list > ul {
    list-style-image: none;
    list-style-type: disc;
    margin: 0 auto;
  }

  .dh-psy-list {
    margin: 0 auto;
    & li {
      color: #14a081;
      padding-bottom: calc(0.5em * 1.2);
    }

    & span {
      color: #393939;

      & :global(a[href]) {
        color: #14a081;
      }
    }

    &.dh-psy-list--dark {
      & li {
        transition: color 0.5s ease-in-out;
        color: #fff;
      }
      & span {
        transition: color 0.5s ease-in-out;

        color: #fff;
      }
    }
  }
</style>

<script>
export default {
  props: ['item', 'dark']
}
</script>
